import type { Job, ShiftHourWindow } from "../../../../../utils/models";

export type JobCatalogState = { status: "none" } | { status: "loading" } | { status: "error"; retry: () => void } | { status: "ready"; jobs: Job[] };

/** Short weekday codes stored on a rule, Monday first. `shiftDays: []` means every day. */
export const WEEKDAY_CODES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;
export type WeekdayCode = (typeof WEEKDAY_CODES)[number];
export const WEEKDAY_PRESETS: Record<"weekdays" | "weekend", WeekdayCode[]> = {
	weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri"],
	weekend: ["Sat", "Sun"],
};

export const DAYS_IN_WEEK = 7;
export const DEFAULT_WINDOW: ShiftHourWindow = { start: "07:00", end: "19:00" };
/** The stored form of a rule's hour window, and how it reads. */
export const WINDOW_TIME_FORMAT = "HH:mm";
export const WINDOW_DISPLAY_FORMAT = "h:mm a";

export const isWeekdayCode = (code: string): code is WeekdayCode => (WEEKDAY_CODES as readonly string[]).includes(code);
